// Chat snapshots are immutable. Share one metadata lookup index across the
// mounted message/sidebar selectors instead of scanning every saved chat for
// each row on every streaming update. Weak keys release superseded snapshots.
const indexes = new WeakMap();

export function findChatById(chats, id) {
  if (!Array.isArray(chats) || Number.isNaN(id)) return undefined;
  let index = indexes.get(chats);
  if (!index) {
    index = new Map();
    for (const chat of chats) {
      // Match the existing strict id comparison and first duplicate, without
      // coercing IDs or treating Mongo _id as an alias for a chat's public id.
      if (chat && !index.has(chat.id)) index.set(chat.id, chat);
    }
    indexes.set(chats, index);
  }
  return index.get(id);
}
